import React from "react";
// import { useState } from "react";
import '../assets/css/AboutUs.css';

// Note: Team member images are commented out as the team section is not currently displayed
// import PresidentImage from '../assets/picture_assets/officials/sample1.jpg';
// import VPImage from '../assets/picture_assets/officials/sample1.jpg';
// import CTOImage from '../assets/picture_assets/officials/sample1.jpg';
// import TalentDirectorImage from '../assets/picture_assets/officials/sample1.jpg';
// import ClientSuccessImage from '../assets/picture_assets/officials/sample1.jpg';

const AboutUs = () => {
  // Note: Team members section is currently commented out
  // const [expandedMember, setExpandedMember] = useState(null);

  // const teamMembers = [
  //   {
  //     id: 1,
  //     name: "Juan Dela Cruz",
  //     position: "President & CEO",
  //     image: PresidentImage, 
  //     bio: "With over 15 years of experience in the BPO industry, Juan founded BPD Online Corp with a vision to connect global businesses with top-tier Filipino talent. He previously held executive positions at major international outsourcing firms.",
  //     expertise: ["Business Strategy", "Operations Management", "Leadership"],
  //     quote: "Our success is measured by the growth of our clients and the careers we build for our team."
  //   },
  //   {
  //     id: 2,
  //     name: "Maria Santos",
  //     position: "Vice President of Operations",
  //     image: VPImage,
  //     bio: "Maria brings 12 years of experience in virtual assistant management and training. She has developed BPD's comprehensive training programs that ensure our VAs meet international standards of excellence.",
  //     expertise: ["Process Optimization", "Training & Development", "Quality Assurance"],
  //     quote: "We don't just provide assistants; we deliver solutions that transform businesses."
  //   },
  //   {
  //     id: 3,
  //     name: "Robert Lim",
  //     position: "Chief Technology Officer",
  //     image: CTOImage,
  //     bio: "Robert leads our technology initiatives, ensuring that BPD stays at the forefront of remote work solutions. He has pioneered several innovative tools that enhance productivity and communication between clients and VAs.",
  //     expertise: ["Software Development", "System Architecture", "Cybersecurity"],
  //     quote: "Technology should enable human potential, not replace it."
  //   },
  //   {
  //     id: 4,
  //     name: "Andrea Reyes",
  //     position: "Director of Talent Acquisition",
  //     image: TalentDirectorImage,
  //     bio: "Andrea heads our recruitment team, using her expertise to identify and select the most skilled Filipino professionals. She has implemented rigorous screening processes that ensure only the top 5% of applicants join our team.",
  //     expertise: ["Recruitment Strategies", "Talent Assessment", "HR Management"],
  //     quote: "The right talent in the right role can transform any business."
  //   },
  //   {
  //     id: 5,
  //     name: "Michael Ocampo",
  //     position: "Client Success Manager",
  //     image: ClientSuccessImage,
  //     bio: "Michael ensures that our clients achieve their business objectives through our VA services. He works closely with each client to understand their unique needs and matches them with the perfect VA.",
  //     expertise: ["Client Relations", "Account Management", "Business Consulting"],
  //     quote: "Your success is our most important metric."
  //   }
  // ];  
  
  // const toggleExpand = (id) => {
  //   if (expandedMember === id) {
  //     setExpandedMember(null);
  //   } else {
  //     setExpandedMember(id);
  //   }
  // };

  return (
    <section id="about" className="about-us">
      <div className="container">
        <div className="section-header">
          <h2>About BPD Online Corp</h2>
          <div className="header-divider"></div>
          <p className="about-intro">
            BPD Online Corp is a Philippine-based corporation specializing in Managed Virtual Assistant and BPO Staffing Solutions. 
            We connect global businesses with skilled Filipino professionals, providing reliable, cost-effective, and scalable support.
          </p>
        </div>
        
        {/*
        <div className="leadership-section">
          <div className="section-header">
            <h3>Our Leadership Team</h3>
            <div className="header-divider"></div>
            <p className="section-description">
              Meet the passionate professionals dedicated to delivering excellence in virtual assistance services.
            </p>
          </div>
          
          <div className="team-grid">
            {teamMembers.map(member => (
              <div 
                key={member.id} 
                className={`team-member-card ${expandedMember === member.id ? 'expanded' : ''}`}
              >
                <div className="member-basic-info">
                  <div className="member-image">
                    <img src={member.image} alt={member.name} />
                    <div className="image-overlay"></div>
                  </div>
                  <h4>{member.name}</h4>
                  <p className="position">{member.position}</p>
                  
                  <button 
                    className="expand-button"
                    onClick={() => toggleExpand(member.id)}
                    aria-expanded={expandedMember === member.id}
                  >
                    {expandedMember === member.id ? 'Show Less' : 'Learn More'}
                    <span className={`arrow ${expandedMember === member.id ? 'up' : 'down'}`}></span>
                  </button>
                </div>
                
                <div className="member-details">
                  <p className="bio">{member.bio}</p>
                  
                  <div className="expertise">
                    <h5>Areas of Expertise:</h5>
                    <ul>
                      {member.expertise.map((skill, index) => (
                        <li key={index}>{skill}</li>
                      ))}
                    </ul>
                  </div>
                  
                  <blockquote className="member-quote">
                    "{member.quote}"
                  </blockquote>
                </div>
              </div>
            ))}
          </div>
        </div>
        */}
        
        
      </div>
    </section>
  );
};

export default AboutUs;